import React from 'react';
import { 
  MessageSquare, 
  ShieldCheck, 
  PhoneCall, 
  Headset, 
  Mail, 
  Instagram, 
  MessageCircleMore, // Closest match to your uploaded image
  BookOpen, 
  Mic, 
  Send 
} from 'lucide-react';

const Technology = () => {
  const products = [
    { name: 'Bulk SMS', icon: <MessageSquare className="w-8 h-8 text-orange-600" /> },
    { name: 'OTP', icon: <ShieldCheck className="w-8 h-8 text-gray-600" /> },
    { name: 'IVR', icon: <PhoneCall className="w-8 h-8 text-purple-600" /> },
    { name: 'Live Chat', icon: <Headset className="w-8 h-8 text-orange-500" /> },
    { name: 'Email', icon: <Mail className="w-8 h-8 text-blue-600" /> },
    { name: 'Instagram', icon: <Instagram className="w-8 h-8 text-pink-600" /> },
    { name: 'WhatsApp', icon: <MessageCircleMore className="w-8 h-8 text-green-500" /> }, // Updated to match image
    { name: 'LMS', icon: <BookOpen className="w-8 h-8 text-blue-600" /> },
    { name: 'Voice API', icon: <Mic className="w-8 h-8 text-red-500" /> }, 
    { name: 'Telegram', icon: <Send className="w-8 h-8 text-sky-500" /> },
  ];

  return (
    <section className="py-16 bg-slate-50">
      <div className="max-w-6xl mx-auto px-4">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-6xl font-semibold text-gray-900 mb-4 -mt-16">
            Your Growth. <span style={{ color: '#F46653' }}>Our Technology.</span>
          </h1>
        </div>

        {/* Grid Section */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mt-16">
          {products.map((product, index) => (
            <div 
              key={index}
              className="bg-[#EEF2FC] rounded-3xl p-8 flex flex-col items-center justify-center shadow-sm border border-gray-100 hover:shadow-md transition-shadow aspect-square hover:bg-white"
            >
              <div className="mb-4 bg-gray-50 p-4 rounded-2xl">
                {product.icon}
              </div>
              <h3 className="text-gray-800 font-semibold text-center text-lg">
                {product.name}
              </h3>
              <span className="mt-1 text-[10px] font-bold text-gray-600 border border-gray-300 px-2 py-0.5 rounded uppercase tracking-widest">
                API
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Technology;